module.exports = __webpack_public_path__ + "static/img/22e.bc4da45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22e.jpg
// module id = 1pld
// module chunks = 0